import { useMutation, useQueryClient } from "react-query"
import { addCustomArticleItems } from "../addCustomArticleItems"
import { QUERY_KEY_ARTICLES } from "./keys"
import { InfiniteState } from "../../hooks/types"
import { CustomArticleItemResponse } from "../models"

export function useAddCustomArticleItem() {
    const queryClient = useQueryClient()
    return useMutation(addCustomArticleItems, {
        onSuccess: (response, request) => {
            queryClient
                .getQueryCache()
                .findAll(QUERY_KEY_ARTICLES)
                .forEach((query) => {
                    if (request.customArticleItemsToAdd.some((x) => x.customArticleListId === query.queryKey[1])) {
                        queryClient.setQueryData<InfiniteState<CustomArticleItemResponse[]>>(query.queryKey, (prev) => ({
                            ...prev,
                            pages:
                                prev?.pages.map((page, index) => ({
                                    ...(index === 0 ? { ...page, data: [...(response?.addedCustomArticleItems ?? []), ...page.data] } : page),
                                })) ?? [],
                        }))
                    }
                })
        },
    })
}
